import { RequestStatus } from '../../constants';

import packageContext from './package-context';

export type RequestCompletePayload<T> = {
	data: T;
	status: RequestStatus.COMPLETE;
};

export type RequestErrorPayload = {
	data: null;
	error: any;
	status: RequestStatus.ERROR;
};

export function isLocalHost() {
	const host = window.location.host;
	return host.includes('localhost') && host.includes(':');
}

export async function fetchJSON<T>(
	url: string,
	init?: RequestInit,
): Promise<RequestCompletePayload<T> | RequestErrorPayload> {
	try {
		const response = await fetch(url, {
			...init,
			credentials: 'include',
			headers: {
				'Atl-BFF-Payload-Version': packageContext.packageVersion,
				...init?.headers,
			},
		});

		const jsonResponse = await response.json();

		return {
			status: RequestStatus.COMPLETE,
			data: jsonResponse,
		};
	} catch (e) {
		return {
			status: RequestStatus.ERROR,
			error: e,
			data: null,
		};
	}
}
